import { Box, Flex, Spinner, Text, Divider } from "@chakra-ui/react";

import { formatNumber } from "@utils/globalCommon";

import { TextSecondary } from "theme";

import { useDappSDKProvider } from "dapp-sdk-v2";

const NodeOperatorBond = () => {
  const { tvlData, nodeOperatorsBond } = useDappSDKProvider();

  return (
    <Box fontSize={{ base: "12px", xl: "14px" }} fontWeight="600">
      <Flex gap="6px" alignItems="center">
        {nodeOperatorsBond.isLoading ? (
          <Spinner size="xs" pb="2px" />
        ) : (
          <>
            {nodeOperatorsBond.data.totalNodeOperatorBonding && (
              <>
                <Text>
                  {formatNumber(
                    nodeOperatorsBond.data.totalNodeOperatorBonding,
                    true,
                    0
                  )}{" "}
                  {process.env.NEXT_PUBLIC_TOKEN}
                </Text>
                <Divider
                  borderColor="textTertiary"
                  orientation="vertical"
                  borderWidth="1px"
                  height="8px"
                />
                {tvlData?.tvl && (
                  <TextSecondary>
                    {`$${
                      formatNumber(
                        Number(
                          Number(
                            nodeOperatorsBond.data.totalNodeOperatorBonding
                          ) * tvlData.tvl.usdPrice
                        ),
                        true,
                        0
                      ) || "0"
                    }`}
                  </TextSecondary>
                )}
              </>
            )}
          </>
        )}
      </Flex>
    </Box>
  );
};

export default NodeOperatorBond;
